<template>
  <div>
    <div
      v-if="resolveSignature(item) === this.messages.originatorWithSignature"
    >
      <v-hover>
        <template v-slot:default="{ hover }">
          <v-card
            class="mx-auto"
            tile
            max-width="150"
          >
            <v-img
              :src="`/v1/users/${item._id}/file?=${item.signature[0].file_name}`"
            />
            <v-fade-transition>
              <v-overlay
                v-if="hover"
                absolute
                color="#036358"
              >
                <v-btn
                  x-small
                  text
                  @click="() => $emit('addSignature', item)"
                >
                  Manage Signature
                </v-btn>
              </v-overlay>
            </v-fade-transition>
          </v-card>
        </template>
      </v-hover>
    </div>
    <v-btn
      v-else-if="resolveSignature(item) === this.messages.originator"
      @click="$emit('addSignature', item)"
      color="primary"
      small
      v-if-has-permission="addSignaturePermission"
    >
      Add Signature
    </v-btn>
    <span v-else>N/A</span>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
  },
  data() {
    return {
      messages: {
        empty: 'N/A',
        originatorWithSignature: 'show-image',
        originator: 'add-image',
      },
    };
  },
  computed: {
    addSignaturePermission: vm => vm.$permissions.ADD_SIGNATURE_TO_USERS,
  },
  methods: {
    resolveSignature(item) {
      const isOriginator = item.groups.includes('loans:account_executives');
      let message = this.messages.empty;
      if (isOriginator && item.signature && item.signature.length > 0 && item.signature[0].active) {
        message = this.messages.originatorWithSignature;
      } else if (isOriginator) {
        message = this.messages.originator;
      }
      return message;
    },
  },
};
</script>
